module.exports = __webpack_public_path__ + "f1fef0271f1f8ca88110f3b0fef584a8.svg";


//////////////////
// WEBPACK FOOTER
// ./images/space_it.svg
// module id = ./images/space_it.svg
// module chunks = 5